/**
 * Facet: Accordion - Indicator
 *
 * Implements functionality where changed fields inside accordions cause
 * an indicator text to appear next to the accordion label.
 */

(() => {
    /**
     * How many character can the label and indicator contain before the indicator is truncated.
     */
    const maximumCharaters = 30;

    let facets = document.querySelector('.js-facets');
    let accordions = document.querySelectorAll('.js-facet-accordion');

    // validate
    if (!facets || !accordions.length) {
        return;
    }

    function truncateDateRange(text, start_date_string, end_date_string) {
        const start_date = H_Tools.date.toDateObject(start_date_string);
        const end_date = H_Tools.date.toDateObject(end_date_string);

        if (!H_Tools.date.areInOrder(start_date, end_date)) {
            return text;
        }

        if (start_date.year === end_date.year) {
            return start_date.month === end_date.month
                ? start_date.day + '.-' + end_date_string
                : start_date.day +
                      '.' +
                      start_date.month +
                      '. - ' +
                      end_date_string;
        }

        return start_date_string + ' - ' + end_date_string;
    }

    function truncateIndicatorText(text, text_elements) {
        const month_labels_long = [
            months_long.january,
            months_long.february,
            months_long.march,
            months_long.april,
            months_long.may,
            months_long.june,
            months_long.july,
            months_long.august,
            months_long.september,
            months_long.october,
            months_long.november,
            months_long.december,
        ].map((value) => H_Tools.string.ucfirst(value));

        const month_labels_short = [
            months_short.january,
            months_short.february,
            months_short.march,
            months_short.april,
            months_short.may,
            months_short.june,
            months_short.july,
            months_short.august,
            months_short.september,
            months_short.october,
            months_short.november,
            months_short.december,
        ].map((value) => H_Tools.string.ucfirst(value));

        // Replace every permutation of a list of consecutive months into a shorter format
        // For example 'January, February' will become 'Jan-Feb'
        // ---
        // i = index of start month
        // j = index of end month
        for (let i = 0; i < 11; i++) {
            for (let j = 11; j > i; j--) {
                let replace = month_labels_long.slice(i, j + 1).join(', ');
                // console.log(replace);
                text = text.replace(
                    replace,
                    month_labels_short[i] + '-' + month_labels_short[j]
                );
            }
        }

        // Replace long month names with short names
        for (let i = 0; i < 12; i++) {
            text = text.replace(month_labels_long[i], month_labels_short[i]);
        }

        if (text_elements.length === 2) {
            text = truncateDateRange(text, text_elements[0], text_elements[1]);
        }

        return text;
    }

    function addIndicator(accordion) {
        // console.log('Adding indicator to accordion...');

        let button = accordion.querySelector('.js-accordion-button');

        if (!button) {
            return;
        }

        // console.log('... Button was found!');
        // console.log(button);

        let inputs = accordion.querySelectorAll('.js-facet-input');

        let selected_count = 0;
        let selected_labels = [];

        inputs.forEach((input) => {
            let text = '';

            if (['checkbox', 'radio'].includes(input.type) && input.checked) {
                selected_count++;

                let label = input.parentElement.querySelector(
                    '.js-facet-label-text'
                );

                if (!label) {
                    return;
                }

                text = label.innerText.trim();
            }

            if (input.type === 'text' && input.value) {
                selected_count++;
                text = input.value;
            }

            if (text) {
                selected_labels.push(text);
            }
        });

        // Update aria-description
        // -----------------------

        button.setAttribute(
            'title',
            button.getAttribute('data-description-modified') +
                ': ' +
                selected_labels.join(', ')
        );
        button.classList.add('-fields-modified');

        // Update visible indicator text
        // -----------------------------

        let indicator = accordion.querySelector(
            '.js-faceted-search-accordion-indicator'
        );

        if (!indicator) {
            return;
        }

        const selected_labels_unique = [...new Set(selected_labels)];

        const label_text = button.getAttribute('data-label');
        const indicator_text = truncateIndicatorText(
            selected_labels_unique.join(', '),
            selected_labels_unique
        );

        if (
            indicator_text !== '' &&
            indicator_text.length < maximumCharaters - label_text.length
        ) {
            indicator.innerHTML = indicator_text;
        } else {
            indicator.innerHTML = '(' + selected_count + ')';
        }
    }

    function removeIndicator(accordion) {
        // console.log('Removing indicator from accordion...');

        let button = accordion.querySelector('.js-accordion-button');
        if (button) {
            button.setAttribute('title', '');
            button.classList.remove('-fields-modified');
        }

        let indicator = accordion.querySelector(
            '.js-faceted-search-accordion-indicator'
        );
        if (indicator) {
            indicator.innerHTML = '';
        }
    }

    function updateIndicator(accordion) {
        // console.log('Updating indicator state of accordion...');

        let fields_modified = false;

        let checkboxes = accordion.querySelectorAll('input[type=checkbox]');
        if (checkboxes.length) {
            checkboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    fields_modified = true;
                }
            });
        }
        let text_inputs = accordion.querySelectorAll('input[type=text]');
        if (text_inputs.length) {
            text_inputs.forEach((input) => {
                if (input.value) {
                    fields_modified = true;
                }
            });
        }

        if (fields_modified) {
            addIndicator(accordion);
        } else {
            removeIndicator(accordion);
        }
    }

    function inputChanged(e) {
        // console.log('Accordion input changed...');

        let accordion = e.currentTarget.closest('.js-facet-accordion');

        if (!accordion) {
            return;
        }

        updateIndicator(accordion);
    }

    accordions.forEach((accordion) => {
        let checkboxes = accordion.querySelectorAll('input[type=checkbox]');
        if (checkboxes.length) {
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', inputChanged);
            });
        }
        let text_inputs = accordion.querySelectorAll('input[type=text]');
        if (text_inputs.length) {
            text_inputs.forEach((input) => {
                input.addEventListener('input', inputChanged);
            });
        }
        updateIndicator(accordion);
    });
})();
